import { useEffect, useState } from "react";
import cyberpackImg from "../Images/CyberPack/Jpgs/Cyberpack-03_v2.png";
import { useLocation, useNavigate } from "react-router-dom";
import * as routes from "../Data/Routes";
import { ScrollToSection } from "../HelperFunctions/Helpers";

export const NewHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Accessing the current route
  const currentRoute = location.pathname;
  const [headerIndex, setHeaderIndex] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [bgColor, setBgColor] = useState("bg-[#1B1B22]");
  const [textColor, setTextColor] = useState("text-[#0FB8F9]");
  const [textColor2, setTextColor2] = useState("text-[#F5F5F5]");

  useEffect(() => {
    const handleScroll = () => {
      // Update the scroll position
      setScrollPosition(window.scrollY);
    };

    // Add the event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (currentRoute !== "/") {
      // if (scrollPosition > 80) {
      //   setBgColor("bg-[#1B1B22]");
      //   setTextColor("text-[#0FB8F9]");
      //   setTextColor2("text-[#F5F5F5]");
      // } else if (scrollPosition < 80) {
      //   setBgColor("bg-transparent");
      //   setTextColor("text-[#F5F5F5]");
      //   setTextColor2("text-main");
      // }
    } else {
      if (scrollPosition > 80) {
        setTextColor("text-[#0FB8F9]");
        setTextColor2("text-[#F5F5F5]");
      } else if (scrollPosition < 80) {
        setTextColor("text-[#0FB8F9]");
        setTextColor2("text-[#F5F5F5]");
      }
    }
  }, [scrollPosition, currentRoute]);

  useEffect(() => {
    if (currentRoute !== "/") {
      // setBgColor("bg-transparent");
    } else {
      setBgColor("bg-[#1B1B22]");
    }
  }, [currentRoute]);

  return (
    <div
      className={`${bgColor} w-screen px-[5vw] flex items-center h-[80px] fixed top-0 left-0 right-0 z-[20]`}
    >
      <img
        id="home"
        src={cyberpackImg}
        alt="cyberpack"
        className="w-[187px] cursor-pointer"
        onClick={() => navigate(routes.homepage)}
      />
      <div className="ml-auto hidden lg:flex items-center gap-x-8">
        <div
          onClick={() => {
            setHeaderIndex(0);
            ScrollToSection("home");
            navigate(routes.homepage);
          }}
          className={`${
            headerIndex === 0 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          HOME
        </div>
        <div
          onClick={() => {
            setHeaderIndex(1);
            ScrollToSection("our-services");
            if (currentRoute !== "/") {
              navigate(routes.homepage);
              setTimeout(() => {
                ScrollToSection("our-services");
              }, 500);
            }
          }}
          className={`${
            headerIndex === 1 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          OUR SERVICES
        </div>
        <div
          onClick={() => {
            setHeaderIndex(2);
            ScrollToSection("our-work");
            if (currentRoute !== "/" && currentRoute !== "/product-design") {
              navigate(routes.homepage);
              setTimeout(() => {
                ScrollToSection("our-work");
              }, 500);
            }
          }}
          className={`${
            headerIndex === 2 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          OUR WORK
        </div>
        <div
          onClick={() => {
            setHeaderIndex(3);
            ScrollToSection("our-people");
            navigate(routes.meetTheTeam);
          }}
          className={`${
            headerIndex === 3 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          OUR TEAM
        </div>
        <div
          onClick={() => {
            setHeaderIndex(4);
            ScrollToSection("career");
          }}
          className={`${
            headerIndex === 4 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          CAREERS
        </div>
        <div
          onClick={() => {
            setHeaderIndex(5);
            ScrollToSection("contact-us");
          }}
          className={`${
            headerIndex === 5 ? textColor : textColor2
          } text-base font-semibold hover:cursor-pointer`}
        >
          CONTACT
        </div>
      </div>
    </div>
  );
};
